module.exports = new __parcel__URL__("little_lemon_tree_level_2.c0c945c7.png").toString();